
  var _styles = {
  "hotel-dynamic-poi-list-card-wrap": {
    "display": "flex",
    "width": "100%",
    "justifyContent": "space-between",
    "flexDirection": "row",
    "flexWrap": "wrap"
  },
  "hotel-dynamic-poi-list-container": {
    "width": "100%",
    "paddingLeft": "0.16rem",
    "paddingRight": "0.16rem",
    "display": "flex",
    "flexDirection": "column"
  },
  "hotel-dynamic-poi-list-show-more-text": {
    "fontWeight": "400",
    "fontFamily": "PingFang SC",
    "fontSize": "0.32rem",
    "color": "rgb(34,34,34)",
    "letterSpacing": 0,
    "lineHeight": "0.45333rem"
  },
  "hotel-dynamic-poi-list-show-more-arrow-container": {
    "transform": "rotate(180deg)"
  },
  "hotel-dynamic-poi-list-show-more-arrow": {
    "lineHeight": "0.26667rem",
    "color": "rgb(85,85,85)"
  },
  "hotel-dynamic-poi-list-show-more-button": {
    "width": "2.24rem",
    "height": "0.8rem",
    "background": "#fff",
    "marginTop": "0.32rem",
    "borderRadius": "0.4rem",
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "center"
  },
  "hotel-dynamic-poi-list-show-more-container": {
    "display": "flex",
    "alignItems": "center",
    "justifyContent": "center"
  },
  "hotel-dynamic-poi-list-no-more-container": {
    "display": "flex",
    "alignItems": "center",
    "justifyContent": "center"
  },
  "hotel-dynamic-poi-list-no-more-text": {
    "fontWeight": "400",
    "fontFamily": "PingFang SC",
    "fontSize": "0.32rem",
    "color": "rgb(153,153,153)",
    "letterSpacing": 0,
    "lineHeight": "0.4rem"
  },
  "hotel-dynamic-poi-list-load-more-sensor": {
    "height": "0.8rem",
    "width": "100%",
    "opacity": 0
  },
  "hotel-dynamic-poi-list-no-data-container": {
    "display": "flex",
    "width": "100%",
    "height": "10rem",
    "flexDirection": "column",
    "alignItems": "center",
    "justifyContent": "center"
  },
  "hotel-dynamic-poi-list-fallback-image-container": {
    "display": "flex",
    "width": "100%",
    "flexDirection": "column",
    "alignItems": "center"
  },
  "hotel-dynamic-poi-list-no-data-text": {
    "fontFamily": "PingFang SC",
    "width": "8.66667rem",
    "textAlign": "center"
  },
  "hotel-dynamic-poi-list-no-data-img": {
    "marginTop": "0.16rem",
    "width": "100%"
  },
  "hotel-dynamic-poi-list-row-type-show-more-button": {
    "marginLeft": "0.26667rem",
    "display": "flex",
    "justifyContent": "center"
  },
  "hotel-dynamic-poi-list-row-type-show-more-view": {
    "width": "0.66667rem",
    "paddingTop": "0.26667rem",
    "paddingRight": "0.06667rem",
    "paddingBottom": "0.26667rem",
    "paddingLeft": "0.06667rem",
    "borderRadius": "0.33333rem",
    "backgroundColor": "rgba(0,0,0,0.4)"
  },
  "hotel-dynamic-poi-list-row-type-show-more-text": {
    "color": "rgb(255,255,255)",
    "fontSize": "small",
    "textAlign": "center"
  },
  "hotel-dynamic-poi-tag-cntr": {
    "paddingTop": "0.16rem",
    "paddingRight": "0.05333rem",
    "paddingBottom": "0.16rem",
    "paddingLeft": "0.05333rem"
  },
  "hotel-dynamic-poi-tag-item": {
    "paddingTop": 0,
    "paddingRight": "0.24rem",
    "paddingBottom": 0,
    "paddingLeft": "0.24rem",
    "borderRadius": "0.16rem",
    "background": "#f4f4f4",
    "marginRight": "0.16rem",
    "height": "0.8rem",
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center"
  },
  "hotel-dynamic-poi-tag-text": {
    "color": "rgb(102,102,102)",
    "fontFamily": "PingFang SC",
    "fontWeight": "400",
    "fontSize": "0.32rem"
  },
  "hotel-dynamic-poi-tag-text-selected": {
    "color": "rgb(255,75,16)"
  },
  "recommend-tips": {
    "display": "flex",
    "alignItems": "center",
    "justifyContent": "center",
    "marginBottom": "0.32rem"
  },
  "hotel-dynamic-poi-list-three-column-wrap": {
    "display": "flex",
    "flexDirection": "row",
    "flexWrap": "wrap",
    "justifyContent": "space-between",
    "width": "100%",
    "paddingTop": 0,
    "paddingRight": "0.16rem",
    "paddingBottom": 0,
    "paddingLeft": "0.16rem"
  }
};

  if (typeof FontFace === 'function') {
    
    var fontFace0 = new FontFace('MTfin-bold2', 'url("https://s0.meituan.net/bs/tempfs/file/dongxiaoxue/MTfin-bold2.0.ttf") format("truetype")');
    document.fonts.add(fontFace0);
    
    var fontFace1 = new FontFace('MTNewDigitalDisplay-Bold', 'url("https://s3plus.meituan.net/tex-external-advertising/MTNewDigitalDisplay-Bold.otf") format("opentype")');
    document.fonts.add(fontFace1);
    
  }
    


  module.exports = _styles;
  